<template>
    <section>
        <div class="modal fade text-start" tabindex="-1" role="dialog" ref="modal" aria-labelledby="modal-title" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 id="modal-title" class="modal-title" v-if="title">{{ title }}</h5>
                        <button type="button"
                                class="btn-close"
                                data-bs-dismiss="modal"
                                :aria-label="$t('modal.close')"
                                @click="close">
                        </button>
                    </div>
                    <div class="modal-body">
                        <slot></slot>
                    </div>
                </div>
            </div>
        </div>
        <!-- TODO: The backdrop tag should not be explicitly added below. Why? -->
        <div class="modal-backdrop show fade"></div>
    </section>
</template>

<script>
    import { Modal } from 'bootstrap'

    export default {
        name: 'Modal',
        props: {
            show: {
                type: Boolean,
                default: false
            },
            title: String
        },
        data() {
            return {
                modal: null
            }
        },
        mounted() {
            // Init Bootstrap Modal
            let options = {
                backdrop: false
            }
            this.modal = new Modal(this.$refs['modal'], options)
            this.modal.show()

            // Listen to events
            this.$refs['modal'].addEventListener('hidden.bs.modal', this.close)
        },
        beforeDestroy() {
            this.$refs['modal'].removeEventListener('hidden.bs.modal', this.close)
        },
        methods: {
            close() {
                this.$emit('close')
            }
        }
    }
</script>
